import {get} from "lodash"
import BaseService from "./Base"

export default class ShiftsService extends BaseService {
    getAll = async (params = {}): Promise<{total: number; data: any[]}> => {
        const response = await this.post("/v1/settings/shifts/list", params)
        return get(response, "data", {})
    }

    create = async (data: any): Promise<any> => {
        const response = await this.post("/v1/settings/shifts/create", data)
        return get(response, "data.data", {})
    }

    update = async (data: any): Promise<any> => {
        const response = await this.post("/v1/settings/shifts/edit", data)
        return get(response, "data.data", {})
    }

    delete = async (data: any): Promise<any> => {
        const response = await this.post("/v1/settings/shifts/delete", data)
        return get(response, "data.data", {})
    }

    manualAssign = async (data: {
        shiftIds: number[]
        campusIds: number[]
        majorIds: number[]
        majorVersionIds: number[]
    }): Promise<any> => {
        const response = await this.post("/v1/settings/shifts/manual-assign", data)
        return get(response, "data.data", {})
    }
}
